module.exports = {
  // Needs 2 or more objects in the array
  promoSliderArray: [
    {
      title: 'Early and late summer escapes',
      imgURL: require('../assets/img/src/home/slideshow/early-and-late-summer.png'),
      thumbURL: require('../assets/img/src/home/slideshow/early-and-late-summer.png'),
      bgPosition: 'right 39% center',
      content: {
        title: 'Early and late summer escapes',
        text: "Travelling out of peak season comes with a host of advantages, so if you're not tied to school holidays, we recommend you experience the heart of the Mediterranean during the serene months of May, June, September and October.",
        cta: 'view',
        link: '16',
        linkType: 'page',
        color: '#050817',
        arrow: 'white',
      },
    },
    {
      title: 'Think Exquisite: when only the very best will do',
      imgURL: require('../assets/img/src/home/slideshow/Think-exquisite-slider.png'),
      thumbURL: require('../assets/img/src/home/slideshow/Think-exquisite-slider.png'),
      bgPosition: 'right 75% center',
      content: {
        title: 'Think Exquisite: when only the very best will do',
        text: 'If you’re looking for the very best – effortless sophistication, a discreet team of staff to look after your every need, space in abundance, luxuriant gardens, perfect privacy, pulse-slowing views, and a host of top quality amenities – then try one of our Think Exquisite villas.',
        cta: 'Book Yours Today',
        link: '39',
        linkType: 'page',
        color: '#fff',
        arrow: 'white',
      },
    },
    {
      title: 'Last-minute availability',
      imgURL: require('../assets/img/src/home/slideshow/corsica.png'),
      thumbURL: require('../assets/img/src/home/slideshow/corsica.png'),
      bgPosition: 'right 39% bottom',
      content: {
        title: 'Captivating Corsica, <em>l\'Île de Beauté</em>',
        text: "Rare beauty, infinite variety, millennial traditions, charming historic towns, maquis-scented coastlines, towering mountains, gastronomic delights, and myriad paradisiacal sandy beaches: combine all these elements and one comes close to defining Corsica. Why not fall in love with <em>l'Île de Beauté</em> on your next trip?",
        cta: 'Search villas',
        link: '520',
        linkType: 'collection',
        color: '#fff',
        arrow: 'white',
      },
    },
  ],
};
